import React, { Component } from 'react';
import './style.scss'
import { connect } from 'react-redux';
import withAuth from '../../../components/Services/WithAuth';
// import AuthService from '../../../components/Services/AuthService';
import { Link } from 'react-router-dom';
import {
    Button, Col,
    Row, Card, CardBody, CardHeader, Table, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { fetchRiskFactorDetails, downloadRiskfactorDetails, uploadRiskfactorDetails } from './action';
import fileSaver from 'file-saver';
import { riskFactorDataType } from './helper';
import Modal from '../../../components/UI/Modal/Modal';
import { Preloading } from '../../../components/UI/Preloader/action';
import { toast } from 'react-toastify';
import TableView from './Table/index'
class RiskFactorComponent extends Component {
    constructor() {
        super();
        this.state = {
            selectedId: '',
            editable: false,
            data: {
                sources: [],
                riskFactorScores: []
            },
            modal: false,
            saveSuccess: false,
            sameRiskFactor: false,
            riskFactorType: null,
            shoModal: false,
            body: null
        }
    }
    componentDidMount() {
        this.setState({
            selectedId: this.props.match.params.factorid
        })
        this.props.preloading(true)
        this.props.fetchRiskFactorDetails(this.props.match.params.factorid);
    }
    componentDidUpdate(prevProps) {
        const { riskFactorDetails, riskFactorTemplateError, riskFactorDownloadTemplate, riskFactorUploadTemplate } = this.props
        if (riskFactorDetails !== prevProps.riskFactorDetails) {
            this.props.preloading(false)
            this.setState({
                data: riskFactorDetails
            }, () => {
                const tempRiskType = riskFactorDataType(this.state.data)
                this.setState({
                    riskFactorType: tempRiskType.map(p => {
                        return (
                            <tr className="grey2" key={p.key}>
                                {Object.keys(p).filter(k => k !== 'id').map(k => {
                                    return (
                                        <td className="grey1 w-50" key={p.key + '' + k}>
                                            <div suppressContentEditableWarning="true" contentEditable={this.state.editable} value={k}>
                                                {p[k]}
                                            </div>
                                            {/* {p[k]} */}
                                        </td>);
                                })}
                            </tr>
                        )
                    })
                })
            })
        }
        if (riskFactorDownloadTemplate !== prevProps.riskFactorDownloadTemplate) {
            this.props.preloading(false)
            let blob = new Blob([riskFactorDownloadTemplate.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            fileSaver.saveAs(blob, `${this.state.data.riskFactorName}.xlsx`);
        } else if (riskFactorUploadTemplate !== prevProps.riskFactorUploadTemplate) {
            this.props.preloading(false)
            toast.success(
                <div>
                    <i className="fa fa-check"></i>&nbsp;{riskFactorUploadTemplate.message}
                </div>
            );
        } else if (riskFactorTemplateError !== prevProps.riskFactorTemplateError) {
            if (riskFactorTemplateError.response.status === 401) {
                this.setState({
                    showModal: !this.state.showModal,
                    body: <div>
                        <ModalHeader>Error</ModalHeader>
                        <ModalBody>
                            <p><i className="fa fa-exclamation-circle red"></i>&nbsp;&nbsp;Authorization Error</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="info" onClick={this.handleLogout}> <Link className="py-3 d-inline-block" onClick={this.handleLogout} to="/">Logout</Link></Button>
                        </ModalFooter>
                    </div>
                })
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation"></i>&nbsp;{(riskFactorTemplateError.response && riskFactorTemplateError.response.data) ? riskFactorTemplateError.response.data.message : "Something went wrong! Please try again."}
                    </div>
                );
            }
        }
    }
    close = () => {
        this.setState({ showModal: !this.state.showModal })
    }
    downloadExcel = (event) => {
        this.props.preloading(true)
        event.preventDefault();
        this.props.downloadRiskfactorTemplate(this.state.selectedId);
    }
    uploadExcel = (event) => {
        this.props.preloading(true)
        event.preventDefault();
        const temp = {
            file: event.target.files[0],
            id: this.state.selectedId
        }
        this.props.uploadRiskfactorTemplate(temp)
        event.target.value = ''
    }
    render() {
        return (
            <Col>
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">
                                Risk Factor
                            </h4>
                            <span>
                                <Button outline size="sm" color="primary" className="btn-filter btn-icon mr-3" title="Download Risk Factor" onClick={this.downloadExcel}><i className="icon-download"></i> </Button>
                                <div size="sm" className="btn btn-primary btn-filter btn-icon position-relative mr-3 upload-action" title="Edit Risk Factor">
                                    <input onChange={this.uploadExcel} type="file" name="file" id="file" className="upload-file" title="Edit Risk Factor" />
                                    <i className="icon-upload"></i>
                                </div>
                                <Button outline size="sm" color="primary" className="btn-filter btn-icon position-relative btn-upload-file" title="Delete Risk Factor" onClick={this.handleDelete}><i className="icon-delete"></i></Button>
                            </span>
                        </div>
                        <Card className="mb-4">
                            <TableView data={this.state.data} />
                        </Card>
                        <Card className="mb-4">
                            <CardHeader className="header-blue">
                                <h6 className="mb-0">Scoring Scenarios</h6>
                            </CardHeader>
                            <CardBody className="d-flex text-left justify-content-between p-0">
                                <Table className="table table-bordered mb-0">
                                    <thead className="header-blue">
                                        <tr>
                                            <th className="border-bottom-0 w-50">Factor</th>
                                            <th className="border-bottom-0 w-50">Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.riskFactorType}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                        <Card className="mb-4">
                            <CardHeader className="header-blue">
                                <Row>
                                    <Col>Not Applicable Score</Col>
                                    <Col>Not Available Score</Col>
                                    <Col>Capping Rule(Min-Max)</Col>
                                    <Col>Category</Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col>{this.state.data.notApplicableScore}</Col>
                                    <Col>{this.state.data.notAvailableScore}</Col>
                                    <Col>{this.state.data.minCapFactor} - {this.state.data.maxCapFactor}</Col>
                                    <Col>{this.state.data.category}</Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal show={this.state.showModal} modalClosed={this.close} >
                    {/* {/ <p>Show Modal Data</p > /} */}
                    {this.state.body}
                </Modal>
            </Col >
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    riskFactorDetails: state.riskFactor.fetchRiskFactorDetails,
    riskFactorDetailsError: state.riskFactor.fetchRiskFactorDetailsFailure,
    riskFactorDownloadTemplate: state.riskFactor.donwloadTemplateSuccess,
    riskFactorUploadTemplate: state.riskFactor.uploadTemplateSuccess,
    riskFactorTemplateError: state.riskFactor.uploadTemplateFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchRiskFactorDetails: (id) => { dispatch(fetchRiskFactorDetails(id)) },
    downloadRiskfactorTemplate: (id) => { dispatch(downloadRiskfactorDetails(id)) },
    uploadRiskfactorTemplate: (file) => { dispatch(uploadRiskfactorDetails(file)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(RiskFactorComponent));
// export default RiskFactorComponent;
